import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useClubEventHttp } from '@/core/api/club-events'
import { ClubEvent, ClubEventPayload } from '@/core/models/club-event'

export type ClubEventCollection = {
    data: Array<ClubEvent>,
    meta?: MetaPayload,
    links?: any
}

const state: ClubEventCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const clubEventCollection: Module<ClubEventCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: ClubEventCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: ClubEventPayload) => {
                state.data.push(new ClubEvent(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useClubEventHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: ClubEventCollection): ClubEventCollection => {
            return state
        }
    }
}
